var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LKAsideMenuItem',{attrs:{"to":_vm.linkTo,"label":_vm.label,"count":_vm.count,"new-count":_vm.notViewedCount,"children":_vm.children},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }